import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { TranslationStore } from './state/translation.store';

export const languageInterceptor: HttpInterceptorFn = (request, handler) => {
  const translationStore = inject(TranslationStore);

  return handler(request.clone({ headers: request.headers.set('Language', translationStore.currentLanguage()) }));
};
